var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { position: "relative" } },
    [
      _c("v-card", { attrs: { flat: "" } }, [
        _c("div", { attrs: { id: "controlsContainer" } }, [
          _c(
            "div",
            {
              staticClass:
                "card-title table-controls px-3 d-flex align-center justify-space-between"
            },
            [
              _c("div"),
              _c(
                "div",
                [
                  _c(
                    "v-container",
                    { attrs: { id: "filterContainer" } },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "4", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("global.datatable.search"),
                                  "append-icon": "fas fa-search",
                                  "single-line": ""
                                },
                                model: {
                                  value: _vm.filter.allFields,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "allFields", $$v)
                                  },
                                  expression: "filter.allFields"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "4", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("audit.trackingToken"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.trackingToken,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "trackingToken", $$v)
                                  },
                                  expression: "filter.trackingToken"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { sm: "12", md: "4", cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$t("audit.deliveryOrderId"),
                                  clearable: ""
                                },
                                model: {
                                  value: _vm.filter.deliveryOrderId,
                                  callback: function($$v) {
                                    _vm.$set(_vm.filter, "deliveryOrderId", $$v)
                                  },
                                  expression: "filter.deliveryOrderId"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _c("crud-button", {
                    attrs: {
                      large: "",
                      color: "blue",
                      icon: "fa-sync-alt",
                      tooltip: _vm.$t("global.crud.buttons.refreshTable")
                    },
                    on: {
                      clicked: function($event) {
                        return _vm.search()
                      }
                    }
                  })
                ],
                1
              )
            ]
          )
        ]),
        _c(
          "div",
          { attrs: { id: "dataContainer" } },
          [
            _c("v-data-table", {
              attrs: {
                headers: _vm.headers,
                items: _vm.items,
                options: _vm.options,
                page: _vm.pagination.page,
                "server-items-length": _vm.pagination.totalItems,
                "no-results-text": _vm.$t("global.datatable.noMatchingResults"),
                "no-data-text": _vm.$t("global.datatable.noDataAvailable"),
                "footer-props": {
                  "items-per-page-options": _vm.rowsPerPageItems,
                  "show-first-last-page": true,
                  "show-current-page": true
                },
                loading: _vm.loading,
                light: "",
                "multi-sort": "",
                dense: ""
              },
              on: {
                "update:options": function($event) {
                  _vm.options = $event
                },
                "update:page": function($event) {
                  return _vm.$set(_vm.pagination, "page", $event)
                }
              },
              scopedSlots: _vm._u([
                {
                  key: "body",
                  fn: function({ items }) {
                    return [
                      _c(
                        "tbody",
                        _vm._l(items, function(item) {
                          return _c("tr", { key: item.id }, [
                            _c("td", [_vm._v(_vm._s(item.auditOrder))]),
                            _c("td", [_vm._v(_vm._s(item.trackingToken))]),
                            _c("td", [_vm._v(_vm._s(item.deliveryOrderId))]),
                            _c("td", [_vm._v(_vm._s(item.operation))]),
                            _c("td", [_vm._v(_vm._s(item.countryConsignee))]),
                            _c("td", [
                              _vm._v(_vm._s(item.postalCodeConsignee))
                            ]),
                            _c("td", [_vm._v(_vm._s(item.countryOrigin))]),
                            _c("td", [_vm._v(_vm._s(item.postalCodeOrigin))]),
                            _c("td", [_vm._v(_vm._s(item.clientCode))]),
                            _c("td", [_vm._v(_vm._s(item.shippingService))]),
                            _c(
                              "td",
                              [
                                item.booking === null ||
                                item.booking === undefined
                                  ? _c("span")
                                  : _c("BooleanToIcon", {
                                      attrs: { value: item.booking }
                                    })
                              ],
                              1
                            ),
                            _c(
                              "td",
                              [
                                item.bookingDone === null ||
                                item.bookingDone === undefined
                                  ? _c("span")
                                  : _c("BooleanToIcon", {
                                      attrs: { value: item.bookingDone }
                                    })
                              ],
                              1
                            ),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.transformDate(
                                      item.scheduleDateFrom,
                                      _vm.$t("global.dateTimeFormat")
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.transformDate(
                                      item.scheduleDateTo,
                                      _vm.$t("global.dateTimeFormat")
                                    )
                                  ) +
                                  " "
                              )
                            ]),
                            _c("td", [_vm._v(_vm._s(item.schedulingToken))]),
                            _c("td", [_vm._v(_vm._s(item.textLog))])
                          ])
                        }),
                        0
                      )
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }